import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import HeadSub from '../../../components/comm/HeadSub';
import URL from "../../../constants/url";
import style from './HospitalLinkage.module.css';


const HospitalLinkage = () => {

    const navigate = useNavigate();

    return (
        <>
            <HeadSub title="Hospital Linkage" />
            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">
                    
                        <div className={style['mid-box']}>
                            <div className='animation-2'>
                            
                                <ul>
                                    <li className={style['past']}>
                                        <strong> Seoul St. Mary's Hospital  </strong>
                                        <p>10254384</p>
                                    </li>
                                    <li className={style['ing']}>
                                        <strong> Incheon St. Mary's Hospital  </strong>
                                        <button className={style['link-btn']}>
                                            <span>Link</span>
                                        </button>
                                    </li>
                                    <li className={style['after']}>
                                        <strong> Daejeon St. Mary's Hospital  </strong>
                                        <span>-</span>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1">

                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg">
                                    <span>Connection</span>
                                </button>

                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
            </div>
            
        </>
    )
}

export default HospitalLinkage